import React from "react"
import { useColors } from "@mallardbay/lib-react-components"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faLocationDot } from "@fortawesome/free-solid-svg-icons/faLocationDot"

import AvatarAndInfo from "~components/shared/avatar-and-info"
import { TEST_IDS } from "~config/test-ids"
import type {
    AddressFieldsFragment,
    OutfitterMinimalFieldsFragment,
    PublicOutfitterFieldsFragment,
} from "~graphql/generated/graphql"
import { formatCityStateAndCountry } from "~utils/formatting-helpers"

interface Props {
    readonly outfitter:
        | PublicOutfitterFieldsFragment
        | OutfitterMinimalFieldsFragment
    readonly location: AddressFieldsFragment | null | undefined
}

export default function OutfitterSection({ outfitter, location }: Props) {
    const colors = useColors()

    const cityStateAndCountry = formatCityStateAndCountry(location)

    return (
        <AvatarAndInfo
            avatar={outfitter.avatar?.url}
            name={outfitter.name}
            title={outfitter.name}
            subtitle={cityStateAndCountry || ""}
            icon={
                <FontAwesomeIcon
                    icon={faLocationDot}
                    color={colors.brandDefault}
                />
            }
            testId={TEST_IDS.OUTFITTER_SECTION}
        />
    )
}
